import useSWR from "swr";

import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createCheckoutConfigurationsUrl } from "@is/services";
import { CheckoutConfiguration } from "@is/types";

export const useCheckoutConfigurations = () => {
  const { setApiHeaders } = useManageApiHeaders();

  setApiHeaders();

  const url = createCheckoutConfigurationsUrl();

  const { data, error, isLoading } = useSWR(url, api.get);

  return {
    checkoutConfigurations: data as CheckoutConfiguration[],
    error,
    isLoading,
  };
};
